import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { CommonImagesRoutingModule } from './common-images-routing.module';
import { CommonImagesComponent } from './common-images.component';


@NgModule({
  declarations: [
    CommonImagesComponent
  ],
  imports: [
    CommonModule,
    CommonImagesRoutingModule,
    MatIconModule,
    MatButtonModule
  ],
  exports:[CommonImagesComponent]
})
export class CommonImagesModule { }
